import { env } from '../../config/env';
import { BASIC_AUTH_PROTECTED_PATHS } from '../constants/auth';

const normalizePath = (rawPath = ''): string => {
  const [withoutQuery] = String(rawPath).split('?');
  const withoutOrigin = withoutQuery.replace(/^https?:\/\/[^/]+/i, '');
  return withoutOrigin.startsWith('/') ? withoutOrigin : `/${withoutOrigin}`;
};

/**
 * Kept for callers that still need to know whether a path is Basic-Auth protected.
 * It is NO LONGER used for routing — routing is single-origin (see below).
 */
export const isBasicAuthProtectedPath = (path = ''): boolean => {
  const normalizedPath = normalizePath(path);
  return BASIC_AUTH_PROTECTED_PATHS.some((prefix) => normalizedPath.startsWith(prefix));
};

/**
 * Single-origin routing: EVERY portal request flows through the Basic-Auth proxy.
 *
 * Why: the session lives in an httpOnly cookie, and cookies are scoped by domain.
 * If some requests went direct to the API and others through the proxy (a different
 * host), the login cookie set via the proxy would never be replayed to the API and
 * `/me` would 401. Sending everything through one origin keeps the cookie on a single
 * host. The proxy itself decides per-path whether to inject Basic Auth (it does so only
 * for protected paths that arrive without an access token — cookie or Bearer).
 *
 * If an explicit proxy base is not configured, fall back to same-origin relative
 * requests. In local CRA dev, `setupProxy.js` forwards those to the Basic Auth
 * proxy. Do not fall back to the backend API base here; portal traffic must not
 * bypass the proxy.
 */
export const resolveApiBaseForPath = (_apiBase = '', _path = ''): string => {
  return env.basicAuthProxyBase || '';
};
